import { createSlice } from "@reduxjs/toolkit";
import { getProposal } from "../reduxApi/proposalReduxApi.js";
import { getCountPriceList, getPricelist } from "../reduxApi/PriceRedux.js";

const PriceSlice = createSlice({
  name: "PriceData",
  initialState: {
    PriceList: [],
    PriceListCount: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPricelist.fulfilled, (state, action) => {
      //   console.log("text 34", action.payload);
      state.PriceList = action.payload.data.queryResponse;
    });
    builder.addCase(getCountPriceList.fulfilled, (state, action) => {
      //   console.log("text 34", action.payload);
      state.PriceListCount = action.payload.data.count;
    });
  },
});
// export const { getProposals } = ProposalSlice.actions;
export default PriceSlice.reducer;
